import { Navigate, useLocation } from 'react-router';
import { NotFoundPage } from '~/pages';
import { authDebug } from './authDebug';
import { buildSignInPathWithReturnTo, isAppPath } from './returnTo';

/**
 * Rendered for unknown paths inside <SignedOut>. If the path looks like an
 * authenticated-app page (e.g. /vault/dashboard, /hlx/dashboard), bounce the
 * user through sign-in and let them resume at the original URL after auth.
 * Otherwise fall back to the standard NotFound view.
 */
export const UnauthenticatedFallback = () => {
  const location = useLocation();

  if (isAppPath(location.pathname)) {
    const target = buildSignInPathWithReturnTo(location.pathname, location.search, location.hash);
    authDebug('signed-out.redirect_to_sign_in', {
      pathname: location.pathname,
      target,
    });
    return <Navigate to={target} replace />;
  }

  return <NotFoundPage />;
};
